import { render, staticRenderFns } from "./data-center.vue?vue&type=template&id=12584623&scoped=true&"
import script from "./data-center.vue?vue&type=script&lang=js&"
export * from "./data-center.vue?vue&type=script&lang=js&"
import style0 from "./data-center.vue?vue&type=style&index=0&id=12584623&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12584623",
  null
  
)

export default component.exports